// https://vuex.vuejs.org/en/getters.html
import * as types from "./constants";
import {getTabConfig} from '../utils/vuex'

export default {
  //
    getCurrentOutlet() {
        let outlet_id = this.route.params.outlet_id;
        return !!outlet_id ? this.outlet_form_data[outlet_id] : {};
    },
    getCurrentChain() {
        let chain_id = this.route.params.chain_id;
        return !!chain_id ? this.chains[chain_id] : {};
    },
    getCurrentAccountType() {
        let account_detail = this.route.params.account_detail;
        return !!this.parameters && !!state.parameters['ACCOUNT_TYPE_URI'] ? this.parameters['ACCOUNT_TYPE_URI'][account_detail] : {};
    },
    outletCount() {
        return this.outlets.length;
    },
    getCurrentNodeType: function () {
        let url_prepend = '';
        if (!!this.route.params.subgroup_id && this.route.params.subgroup_id !== '') {
            url_prepend = '/hierarchy/subgroup/' + (this.route.params.subgroup_id)
        } else if(!!this.route.params.outlet_id && this.route.params.outlet_id !== '') {
            url_prepend = '/hierarchy/outlet/' + (this.route.params.outlet_id)
        }

        if (!url_prepend) {
            return 'merchant';
        } else {
            if (!!this.route.params.subgroup_id && this.route.params.subgroup_id !== '') {
                return 'subgroup';
            } else if(!!this.route.params.outlet_id && this.route.params.outlet_id !== '') {
                return 'outlet';
            }
        }

    },
}
